import usePagination, {
  usePaginationReset,
} from "components/Shared/ChakraReactTable/usePagination";
import useGQLSorting, {
  GQLOrderByEnumsById,
} from "components/Shared/ChakraReactTable/useGQLSorting";
import { BASE_ORDER_BY } from "components/Shared/EmailTable/EmailTable";
import { ReceivedEmailMessagesOrderBy } from "__generated__/gql/graphql";

type UseEmailTableStateProps = {
  pageSize?: number;
  orderByEnumsById?: GQLOrderByEnumsById<ReceivedEmailMessagesOrderBy>;
  defaultSorting?: { id: string; desc: boolean }[];
  filter?: unknown;
};

export default function useEmailTableState({
  pageSize = 10,
  orderByEnumsById = BASE_ORDER_BY,
  defaultSorting = [{ id: "receivedAt", desc: true }],
  filter,
}: UseEmailTableStateProps) {
  const { pagination, onPaginationChange, limitOffset, setPageIndex } =
    usePagination({ pageSize });

  const { sorting, onSortingChange, orderBy } = useGQLSorting(
    orderByEnumsById,
    defaultSorting,
  );

  const isPendingFilterReset = usePaginationReset(
    filter,
    setPageIndex,
    pagination.pageIndex,
  );

  const isPendingSortingReset = usePaginationReset(
    sorting,
    setPageIndex,
    pagination.pageIndex,
  );

  const isPendingReset = isPendingFilterReset || isPendingSortingReset;

  return {
    tableProps: {
      pagination,
      onPaginationChange,
      sorting,
      onSortingChange,
    },
    limitOffset,
    orderBy,
    isPendingReset,
  };
}
